import { InjectionToken } from '@angular/core';
import { IEnvironment } from '@shared/core/interfaces/environment.interface';

export const PW_ENVIRONMENT = new InjectionToken<IEnvironment>('PW_ENVIRONMENT');
